var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPasswordFp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 111,
    viewBox: "0 0 84 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 110.5C5.6875 110.5 3.82812 109.734 2.29688 108.203C0.765625 106.672 0 104.812 0 102.625V45.6625C0 43.475 0.765625 41.6156 2.29688 40.0844C3.82812 38.5531 5.6875 37.7875 7.875 37.7875H17.0625V25.1875C17.0625 18.275 19.4906 12.3906 24.3469 7.53438C29.2031 2.67813 35.0875 0.25 42 0.25C48.9125 0.25 54.7969 2.67813 59.6531 7.53438C64.5094 12.3906 66.9375 18.275 66.9375 25.1875V37.7875H76.125C78.3125 37.7875 80.1719 38.5531 81.7031 40.0844C83.2344 41.6156 84 43.475 84 45.6625V102.625C84 104.812 83.2344 106.672 81.7031 108.203C80.1719 109.734 78.3125 110.5 76.125 110.5H7.875ZM7.875 102.625H76.125V45.6625H7.875V102.625ZM42 84.25C44.8 84.25 47.1844 83.2875 49.1531 81.3625C51.1219 79.4375 52.1063 77.1187 52.1063 74.4062C52.1063 71.7812 51.1219 69.3969 49.1531 67.2531C47.1844 65.1094 44.8 64.0375 42 64.0375C39.2 64.0375 36.8156 65.1094 34.8469 67.2531C32.8781 69.3969 31.8937 71.7812 31.8937 74.4062C31.8937 77.1187 32.8781 79.4375 34.8469 81.3625C36.8156 83.2875 39.2 84.25 42 84.25ZM24.9375 37.7875H59.0625V25.1875C59.0625 20.4625 57.4 16.4375 54.075 13.1125C50.75 9.7875 46.725 8.125 42 8.125C37.275 8.125 33.25 9.7875 29.925 13.1125C26.6 16.4375 24.9375 20.4625 24.9375 25.1875V37.7875ZM7.875 102.625V45.6625V102.625Z",
    fill: "url(#paint0_linear_17831_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17831_7",
    x1: -22.4246,
    y1: 17.6922,
    x2: 36.8412,
    y2: 125.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0130144,
    stopColor: "#FEDD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2166,
    stopColor: "#FEC809"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6362,
    stopColor: "#FF9022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5C39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordFp);
export default __webpack_public_path__ + "static/media/resetPasswordFP.85c4e4add30f313c1fc2ca9926294416.svg";
export { ForwardRef as ReactComponent };